// removed by extract-text-webpack-plugin
module.exports = {"content":"Training__content__3LuNS","submitResult":"Training__submitResult__ONXj3","submitWrapper":"Training__submitWrapper__14oUk"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Training/Training.css
// module id = 3538
// module chunks = 0